import { useState } from 'react';

/** Zeittakt der Tagesansicht in Minuten: stündlich, halbstündlich oder viertelstündlich */
export const GRID_STEPS = [60, 30, 15] as const;
export type GridStep = (typeof GRID_STEPS)[number];
export const GRID_STEP_LABELS: Record<GridStep, string> = { 60: 'Stündlich', 30: 'Halbstündlich', 15: 'Viertelstündlich' };

const KEY = 'kontor.shifts.step';

/** Der gewählte Takt, im Browser gemerkt (jeder Benutzer stellt ihn für sich ein) */
export function useGridStep(): [GridStep, (step: GridStep) => void] {
  const [step, setStep] = useState<GridStep>(() => {
    try {
      const saved = Number(localStorage.getItem(KEY));
      return (GRID_STEPS as readonly number[]).includes(saved) ? (saved as GridStep) : 15;
    } catch {
      return 15;
    }
  });
  const change = (next: GridStep) => {
    setStep(next);
    try {
      localStorage.setItem(KEY, String(next));
    } catch {
      // ohne Speicher gilt die Wahl nur bis zum Neuladen
    }
  };
  return [step, change];
}

/** Auswahl des Zeittakts, nur in der Tagesansicht sinnvoll */
export function GridStepSelect({ value, onChange }: { value: GridStep; onChange: (step: GridStep) => void }) {
  return (
    <label className="field shift-toolbar__field">
      <span>Zeitraster</span>
      <select className="input" value={value} onChange={(e) => onChange(Number(e.target.value) as GridStep)}>
        {GRID_STEPS.map((s) => <option key={s} value={s}>{GRID_STEP_LABELS[s]}</option>)}
      </select>
    </label>
  );
}
